import { useContext, useMemo } from 'react';
import { EntriesContext } from '../context/EntriesContext';

export default function useRequestedBy() {
  const { entries } = useContext(EntriesContext);
  return useMemo(
    () => Array.from(new Set(entries.map(e => e.requestedBy).filter(Boolean))),
    [entries]
  );
}
